import React from "react";
import Paper from "@material-ui/core/Paper";
import "../../admin/routes/setup/programme/table.css";
import { CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import applicant from "../../applicant/routes/dashboard/index";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { OSCOHTLogo, cisco } from "assets/images/image";
import "../../components/ApplicantForm/ApplicantForm.print.css";
import moment from "moment";
//import LuminateLogo from "assets/images/sidmach-logo-A.png";
// var LuminateLogo =
//   "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";

// This function is used to display the appliant form for usermode of applicant
class ApplicantForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      olevel: [],
      loadingOlevel: false,
    };
  }

  componentDidMount() {
    const { applicant } = this.props;
    if (applicant?.AdmModeId === 1) {
      this.applicantOlevel();
    }
    this.updatePrintHeaderFooter();
  }
  handleDobValue = (DateOfBirth) => {
    const myDate = new Date(DateOfBirth);
    const dayOfMonth = myDate.getDate();
    const month = myDate.getMonth();
    const year = myDate.getFullYear();
    if (myDate !== "") {
      return year + "-" + this.pad(month + 1) + "-" + this.pad(dayOfMonth);
    }
  };
  pad = (n) => {
    return n < 10 ? "0" + n : n;
  };

  // Convert image to base64 for better download compatibility
  convertToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      };
      img.onerror = () => reject(url);
      img.src = url;
    });
  };

  //function to call the olevel result of the applicant
  applicantOlevel = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      const response = await fetchJSON(
        `api/OResults/NewhasOlevelResult?applicantId=${ApplicantID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Ok") {
        this.setState({
          olevel: response.Data,
        });
      } else {
        NotificationManager.info(response.Message);
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  };

  updatePrintHeaderFooter = () => {
    const { applicant } = this.props;
    const now = new Date().toLocaleString();

    const header = document.getElementById("print-header");
    const footer = document.getElementById("print-footer");

    if (header) {
      header.style.display = "block";
      header.style.textAlign = "center";
      header.style.marginBottom = "20px";
      header.style.borderBottom = "1px solid black";
      header.innerHTML = `
      <h3>Ondo State College of Health Technology, Akure</h3>
      <p>Printed on: ${now}</p>
      <p>Applicant: ${applicant?.LastName || ""} ${applicant?.FirstName ||
        ""}</p>
    `;
    }

    if (footer) {
      footer.style.display = "block";
      footer.style.textAlign = "center";
      footer.style.marginTop = "30px";
      footer.style.borderTop = "1px solid black";
      footer.innerHTML = `
      <p>This document is system-generated and valid for admission purposes.</p>
    `;
    }
  };

  render() {
    const { applicant, loading } = this.props;
    const { olevel } = this.state;

    if (loading) {
      return (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <CircularProgress />
          <p>Loading applicant details...</p>
        </div>
      );
    }

    return (
      <>
        <Paper>
          {/* style={{ display: 'none' }} */}
          {loading ? (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <CircularProgress />
              <p>Loading applicant ...</p>
            </div>
          ) : (
            <div id="content">
              <div className="main-form-container">
                <div className="header-row">
                  <img
                    className="img-fluid"
                    src={OSCOHTLogo}
                    alt="Logo"
                    style={{ maxWidth: "100px", maxHeight: "100px" }}
                  />
                  <div className="header-center">
                    <h1
                      style={{
                        color: "#0c0ca5",
                        fontSize: "25px",
                        marginBottom: 0,
                      }}
                    >
                      <strong>
                        Ondo State College of Health Technology, Akure
                      </strong>
                    </h1>
                    <div
                      style={{
                        color: "#000",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      Information, Communication, Technology
                    </div>
                    <div style={{ color: "#000", fontSize: "15px" }}>
                      website: www.chta.ng
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={cisco}
                      alt="cisco"
                      style={{ width: "400px", height: "100px" }}
                    />
                    <p
                      style={{
                        fontSize: "0.5em",
                        marginBottom: "0.0rem",
                        marginTop: "0.5rem",
                      }}
                    >
                      Networking Academy
                    </p>
                  </div>
                </div>

                {/* Details Section */}
                <div className="container-fluid">
                  <div className="column">
                    <div className="col-lg-12 mt-1">
                      <div className="col-lg-12 text-center mb-3">
                        <p
                          className="p-3"
                          style={{
                            fontSize: "1.5em",
                            fontWeight: "bold",
                            borderRadius: "6px",
                          }}
                        >
                          ENTRANCE SCREENING EXERCISE {applicant?.sessionName}{" "}
                          SESSION
                          <br />
                          APPLICATION SLIP
                        </p>
                      </div>
                    </div>
                  </div>
                  <br />

                  <div className="main-form-container">
                    <div className="passport-row">
                      <img
                        className="passport-img"
                        src={
                          applicant?.Passport
                            ? applicant?.Passport
                            : "https://unicrossdoc.blob.core.windows.net/passport/Avatar.jpg"
                        }
                        alt="Passport"
                      />
                      <div className="programme-details">
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">Registration Number:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.ApplicantNumber}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">First Name:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.FirstName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">Middle Name:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.OtherName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">Last Name (Surname):</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.LastName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">Date of Birth:</p>
                          </div>
                          <div>
                            <p className="mb-1">
                              {this.handleDobValue(applicant?.DateOfBirth)}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">Sex:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.Gender}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">Country:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.CountryName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0 ">State/LGA:</p>
                          </div>
                          <div>
                            <p className="mb-1">
                              {applicant?.StateName} / {applicant?.LGAName}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-3">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">Phone Number:</p>
                          </div>
                          <div>
                            <p className="mb-0">{applicant?.PhoneNumber}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-2">
                          <h5
                            className="mb-2 "
                            style={{ textDecoration: "underline" }}
                          >
                            Programmes/Courses
                            <br /> Desired:
                          </h5>
                        </div>
                        <div className="d-flex mb-2">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">Programme:</p>
                          </div>
                          <div>
                            <p className="mb-0">{applicant?.CategoryName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">Programme Type:</p>
                          </div>
                          <div>
                            <p className="mb-0">{applicant?.ProgramTypeName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">1st Choice Course of Study:</p>
                          </div>
                          <div>
                            <p className="mb-1">{applicant?.DepartmentName}</p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <div style={{ minWidth: "250px" }}>
                            <p className="mb-0">2nd Choice Course of Study:</p>
                          </div>
                          <div>
                            <p className="mb-1">
                              {applicant?.SecondChoiceCourseName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* UTME Section */}

                  {/* Olevel Section */}
                  {/* <div className="container-fluid pt-2 mb-5">
                   <div className="row mx-5">
                     <div className="col">
                       <div className="row">
                         <div className="col-lg-4">
                           <h3
                             className="p-2 text-center"
                             style={{
                               fontSize: "1.5em",
                               fontWeight: "bold",
                               borderRadius: "6px",
                               backgroundColor: "#0c0ca5",
                               color: "white",
                             }}
                           >
                             O'LEVEL RESULT
                           </h3>
                         </div>
                       </div>
       
                       <table id="documentAppForm" className="border">
                         <thead>
                           <tr>
                             <th>Exam Number</th>
                             <th>Year of Exam</th>
                             <th>Type</th>
                             <th>Subject</th>
                             <th>Grade</th>
                           </tr>
                         </thead>
                         <tbody>
                           {olevelResults
                             ? olevelResults?.map((o, i) => (
                                 <tr key={i}>
                                   <td>{o.ExamNumber}</td>
                                   <td>{o.ExamYear}</td>
                                   <td>{o.OLevelTypeName}</td>
                                   <td>{o.OLevelSubjectName}</td>
                                   <td>{o.GradeName}</td>
                                 </tr>
                               ))
                             : ""}
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div> */}
                  {/*ond Detials */}
                  <div className="main-form-container">
                    {applicant?.AdmModeId === 2 && (
                      <div style={{ color: "#000", fontSize: "15px" }}>
                        <div
                          style={{
                            textDecoration: "underline",
                            minWidth: "450px",
                            marginBottom: "1rem",
                          }}
                        >
                          <p className="mb-0 f">OND DETAILS:</p>
                        </div>
                        <div
                          style={{ display: "flex", marginBottom: "0.5rem" }}
                        >
                          <div style={{ minWidth: "200px" }}>
                            <p className="mb-0">Name of Institution:</p>
                          </div>
                          <div>
                            <p className="mb-0">
                              {applicant?.InstitutionAttended} Kwara State
                              Polytechnic, Ilorin
                            </p>
                          </div>
                        </div>
                        <div
                          style={{ display: "flex", marginBottom: "0.5rem" }}
                        >
                          <div style={{ minWidth: "200px" }}>
                            <p className="mb-0">Class of Diploma:</p>
                          </div>
                          <div>
                            <p className="mb-0">{applicant?.ClassOfDiploma}</p>
                          </div>
                        </div>
                        <div
                          style={{ display: "flex", marginBottom: "0.5rem" }}
                        >
                          <div style={{ minWidth: "200px" }}>
                            <p className="mb-0">Graduation Year:</p>
                          </div>
                          <div>
                            <p className="mb-0">
                              {applicant?.YearOfGraduation}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div style={{ marginTop: "2rem" }}>
                      <div
                        style={{
                          textDecoration: "underline",
                          minWidth: "350px",
                          marginBottom: "1rem",
                        }}
                      >
                        <p className="mb-0 font-weight-bold">PAYMENT DETAILS</p>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Category:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.TransactionRefApplication === " " ||
                            null
                              ? ""
                              : "Application Fee"}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Transaction Pin:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.TransactionRefApplication}
                          </p>
                        </div>
                      </div>

                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Amount Paid:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.AmountPaidApplication !== 0
                              ? `₦ ${applicant?.AmountPaidApplication}`
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Status:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.PaymentStatusApplication}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Date:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {moment(applicant?.PaymentDateApplication).format(
                              "MMMM Do YYYY"
                            )}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          textDecoration: "underline",
                          minWidth: "250px",
                          margin: "1rem 0 0.5rem 0",
                        }}
                      >
                        <p className="mb-0 font-weight-bold">
                          O'Level Verification Payment Details:
                        </p>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Title:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.NumberofOlevelSitting !== 0
                              ? `Data Management Fee (${
                                  applicant?.NumberofOlevelSitting
                                } Sitting${
                                  applicant?.NumberofOlevelSitting !== 1
                                    ? "s"
                                    : ""
                                })`
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Transaction Pin:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.TransactionRefDataManagement}
                          </p>
                        </div>
                      </div>

                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Amount Paid:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.AmountPaidDataManagement !== 0
                              ? `₦ ${applicant?.AmountPaidDataManagement}`
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Status:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {applicant?.PaymentStatusDataManagement}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "1rem" }}>
                        <div style={{ minWidth: "200px" }}>
                          <p className="mb-0">Payment Date:</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {moment(
                              applicant?.PaymentDateDataManagement
                            ).format("MMMM Do YYYY")}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          textDecoration: "underline",
                          margin: "1rem 0 0.5rem 0",
                        }}
                      >
                        <p className="font-weight-bold">
                          IMPORTANT INFORMATION:
                        </p>
                      </div>
                      <div style={{ minWidth: "350px" }}>
                        <p className="font-weight-bold">
                          You are required to come along with your a JAMB
                          PART-TIME REGISTRATION Slip on the screening day
                          alongside all your documents.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* HOD Remarks Sectionfor HND */}
                  <div className="main-form-container">
                    {applicant?.AdmModeId == 2 && (
                      <div style={{ color: "#000", fontSize: "15px" }}>
                        <div
                          style={{
                            textDecoration: "underline",
                            marginBottom: "1rem",
                          }}
                        >
                          <p className="font-weight-bold">
                            HEAD OF DEPARTMENT REMARKS:
                          </p>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ marginBottom: "1rem" }}
                        >
                          <span style={{ minWidth: "150px" }}>
                            H.O.D Remarks:
                          </span>
                          <span style={{ flex: 1, marginLeft: "10px" }}>
                            ......................................................................................................................................
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between"
                          style={{ marginBottom: "1rem" }}
                        >
                          {/* LEFT COLUMN */}
                          <div style={{ minWidth: "400px" }}>
                            <div className="d-flex align-items-center">
                              <span>Name of HOD</span>
                              <span>
                                ......................................................
                              </span>
                            </div>
                          </div>
                          {/* RIGHT COLUMN */}
                          <div style={{ flexGrow: 1, marginLeft: "60px" }}>
                            <div className="d-flex mb-2">
                              <div style={{ minWidth: "200px" }}>
                                <p>Signature & Date:</p>
                              </div>
                              <div>
                                <p className="mb-0">
                                  ......................................................................................
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* RECOMENDATION */}
                  <div className="main-form-container">
                    <div style={{ color: "#000", fontSize: "15px" }}>
                      <div
                        style={{
                          textDecoration: "underline",
                          marginBottom: "1rem",
                        }}
                      >
                        <p className="font-weight-bold">
                          RECOMMENDED ADMISSION STATUS:
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-between"
                        style={{ marginBottom: "1rem" }}
                      >
                        {/* LEFT COLUMN */}
                        <div style={{ minWidth: "350px" }}>
                          <div className="d-flex align-items-center mb-2">
                            <span>Recommended</span>
                            <input
                              type="checkbox"
                              style={{
                                width: "15px",
                                height: "15px",
                                margin: "0 10px",
                              }}
                            />
                            <span>
                              Dept.: ....................................
                            </span>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="checkbox"
                              style={{
                                width: "12px",
                                height: "12px",
                                marginRight: "8px",
                              }}
                            />
                            <span>Pending</span>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="checkbox"
                              style={{
                                width: "12px",
                                height: "12px",
                                marginRight: "8px",
                              }}
                            />
                            <span>Not Recommended</span>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="checkbox"
                              style={{
                                width: "12px",
                                height: "12px",
                                marginRight: "8px",
                              }}
                            />
                            <span>HOD Recommended</span>
                          </div>
                        </div>
                        {/* RIGHT COLUMN */}
                        <div style={{ flexGrow: 1, marginLeft: "60px" }}>
                          <div className="d-flex mb-2">
                            <div style={{ minWidth: "200px" }}>
                              <p>Name of Screening Officer:</p>
                            </div>
                            <div>
                              <p className="mb-0">
                                ......................................................................................
                              </p>
                            </div>
                          </div>
                          <div className="d-flex mb-2">
                            <div style={{ minWidth: "200px" }}>
                              <p>Signature & Date:</p>
                            </div>
                            <div>
                              <p className="mb-0">
                                ......................................................................................
                              </p>
                            </div>
                          </div>
                          <div className="d-flex mb-2">
                            <div style={{ minWidth: "200px" }}>
                              <p>Remarks:</p>
                            </div>
                            <div>
                              <p className="mb-0">
                                ......................................................................................
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = ({ settings, auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  return { authUser, userMode };
};

export default connect(mapStateToProps, { applicant })(ApplicantForm);
// import React from "react";
// import Paper from "@material-ui/core/Paper";
// import "../../admin/routes/setup/programme/table.css";
// import { CircularProgress } from "@material-ui/core";
// import { connect } from "react-redux";
// import { fetchJSON } from "helpers/axios";
// import applicant from "../../applicant/routes/dashboard/index";
// import {
//   NotificationContainer,
//   NotificationManager,
// } from "react-notifications";
// import cisco from "../../assets/images/cisco.png";

// // This function is used to display the appliant form for usermode of applicant
// class ApplicantForm extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       olevel: [],
//       loadingOlevel: false,
//     };
//   }

//   componentDidMount() {
//     this.applicantOlevel();
//   }
//   this.handleDobValue = (DateOfBirth) => {
//     const myDate = new Date(DateOfBirth);
//     const dayOfMonth = myDate.getDate();
//     const month = myDate.getMonth();
//     const year = myDate.getFullYear();
//     if (myDate !== "") {
//       return year + "-" + this.pad(month + 1) + "-" + this.pad(dayOfMonth);
//     }
//   };
//   pad = (n) => {
//     return n < 10 ? "0" + n : n;
//   };

//   //function to call the olevel result of the applicant
//   applicantOlevel = async () => {
//     try {
//       const { token, ApplicantID } = this.props.authUser;
//       const response = await fetchJSON(
//         `api/OResults/NewhasOlevelResult?applicantId=${ApplicantID}`,
//         null,
//         "GET",
//         token
//       );
//       if (response.Status === "Ok") {
//         this.setState({
//           olevel: response.Data,
//         });
//       } else {
//         NotificationManager.error(response.Message);
//       }
//     } catch (error) {
//       NotificationManager.error("An error occurred.");
//     }
//   };

//   render() {
//     const { applicant, loading } = this.props;
//     const { olevel } = this.state;

//     if (loading) {
//       return (
//         <div style={{ textAlign: "center", padding: "2rem" }}>
//           <CircularProgress />
//           <p>Loading applicant details...</p>
//         </div>
//       );
//     }

//     return (
//       <>

//         <Paper
//           elevation={2}
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "20px" }}
//         >
//           <div id="content" style={{ maxWidth: "794px", margin: "0 auto" }}>
//             {/* Header Section - Stacked Vertically */}
//             <header
//               className="mt-2"
//               style={{ borderBottom: "1px solid gray", padding: "20px" }}
//             >
//               <div className="container-fluid">
//                 {/* Logo Row */}
//                 <div className="row justify-content-between align-items-center mb-3">
//                   <div className="col-4">
//                     <img
//                       className="img-fluid"
//                       src="https://res.cloudinary.com/dterghv7c/image/upload/v1749715125/shared_image_t7ddp6.jpg"
//                       alt=""
//                       style={{ maxWidth: "80px", maxHeight: "80px" }}
//                     />
//                   </div>
//                   <div className="col-4 text-right">
//                     <img
//                       src={cisco}
//                       alt="cisco"
//                       style={{ maxWidth: "80px", maxHeight: "80px" }}
//                     />
//                   </div>
//                 </div>

//                 {/* Institution Info - Centered */}
//                 <div className="row">
//                   <div className="col-12 text-center">
//                     <h4
//                       style={{
//                         color: "#0c0ca5",
//                         fontSize: "20px",
//                         marginBottom: "5px",
//                       }}
//                     >
//                       <strong>
//                         Ondo State College of Health Technology, Igbesa
//                       </strong>
//                     </h4>
//                     <h6
//                       style={{
//                         color: "#000",
//                         fontSize: "14px",
//                         marginBottom: "5px",
//                       }}
//                     >
//                       (Formerly Gateway Polytechnic, Igbesa)
//                     </h6>
//                     <h6
//                       style={{
//                         color: "#000",
//                         fontSize: "16px",
//                         fontWeight: "bold",
//                         marginBottom: "5px",
//                       }}
//                     >
//                       Information, Communication, Technology
//                     </h6>
//                     <h6 style={{ color: "#000", fontSize: "12px" }}>
//                       website:www.online.OSCOHT.edu.ng
//                     </h6>
//                   </div>
//                 </div>
//               </div>
//             </header>

//             {/* Title Section */}
//             <div className="container-fluid mb-4">
//               <div className="row">
//                 <div className="col-12 text-center">
//                   <h3
//                     className="p-2"
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                       borderRadius: "6px",
//                       margin: "20px 0",
//                     }}
//                   >
//                     Entrance Screening Exercise {applicant?.Session} Session
//                     <br />
//                     Application Slip
//                   </h3>
//                 </div>
//               </div>
//             </div>

//             {/* Passport Photo - Centered */}
//             {/* Image + Programme Section (Side by Side) */}
//             <div className="container-fluid mb-4">
//               <div className="row">
//                 {/* Left - Passport */}
//                 <div className="col-md-4 text-center">
//                   <img
//                     className="img-fluid border"
//                     src={
//                       applicant.Passport != null
//                         ? applicant.Passport
//                         : "https://unicrossdoc.blob.core.windows.net/passport/Avatar.jpg"
//                     }
//                     alt="Passport"
//                     style={{
//                       maxWidth: "150px",
//                       maxHeight: "150px",
//                       marginBottom: "20px",
//                     }}
//                   />
//                 </div>

//                 {/* Right - Programme Details */}
//                 <div
//                   className="col-md-8"
//                   style={{ color: "#000", fontSize: "14px" }}
//                 >
//                   <h5
//                     className="mb-3"
//                     style={{ textDecoration: "underline", fontWeight: "bold" }}
//                   >
//                     Programmes/Courses Desired:
//                   </h5>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">Programme:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.CategoryName}</p>
//                     </div>
//                   </div>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">Programme Type:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.ProgrammeType}</p>
//                     </div>
//                   </div>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">1st Choice Course:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.DepartmentName}</p>
//                     </div>
//                   </div>
//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">1st Choice Course:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.DepartmentName}</p>
//                     </div>
//                   </div>
//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">1st Choice Course:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.DepartmentName}</p>
//                     </div>
//                   </div>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                       <p className="mb-0">2nd Choice Course:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">
//                         {applicant?.SecondChoiceCourseName}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Programme/Courses Section */}

//             {/* Payment Details Section */}
//             <div className="container-fluid mb-3">
//               <div className="row">
//                 <div
//                   className="col-12"
//                   style={{ color: "#000", fontSize: "14px" }}
//                 >
//                   <p
//                     className="mb-2"
//                     style={{ textDecoration: "underline", fontWeight: "bold" }}
//                   >
//                     PAYMENT DETAILS
//                   </p>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "250px", fontWeight: "bold" }}>
//                       <p className="mb-0">Transaction Pin:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.OtherName}</p>
//                     </div>
//                   </div>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "250px", fontWeight: "bold" }}>
//                       <p className="mb-0">Approval Code:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.LastName}</p>
//                     </div>
//                   </div>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "290px", fontWeight: "bold" }}>
//                       <p className="mb-0">Amount Paid:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">
//                         {this.this.handleDobValue(applicant?.DateOfBirth)}
//                       </p>
//                     </div>
//                   </div>

//                   <p
//                     className="mt-3 mb-2"
//                     style={{ textDecoration: "underline", fontWeight: "bold" }}
//                   >
//                     O'Level Verification Payment Details:
//                   </p>

//                   <div className="d-flex mb-2">
//                     <div style={{ minWidth: "250px", fontWeight: "bold" }}>
//                       <p className="mb-0">Approval Code:</p>
//                     </div>
//                     <div>
//                       <p className="mb-0">{applicant?.LastName}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Important Information */}
//             <div className="container-fluid mb-4">
//               <div className="row">
//                 <div
//                   className="col-12"
//                   style={{ color: "#000", fontSize: "14px" }}
//                 >
//                   <h5
//                     className="mb-3"
//                     style={{ textDecoration: "underline", fontWeight: "bold" }}
//                   >
//                     IMPORTANT INFORMATION:
//                   </h5>
//                   <p className="font-weight-bold">
//                     You are required to come along with your JAMB PART-TIME
//                     REGISTRATION Slip on the screening day alongside all your
//                     documents.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Recommended Admission Status */}
//             <div className="container-fluid mb-4">
//               <div className="row">
//                 <div
//                   className="col-12"
//                   style={{ color: "#000", fontSize: "14px" }}
//                 >
//                   <h5
//                     className="mb-3"
//                     style={{ textDecoration: "underline", fontWeight: "bold" }}
//                   >
//                     RECOMMENDED ADMISSION STATUS:
//                   </h5>

//                   {/* Checkboxes Section */}
//                   <div className="mb-4">
//                     <div className="d-flex align-items-center mb-2">
//                       <input
//                         type="checkbox"
//                         className="mr-2"
//                         style={{ width: "15px", height: "15px" }}
//                       />
//                       <span>
//                         Recommended - Dept.:
//                         ....................................
//                       </span>
//                     </div>

//                     <div className="d-flex align-items-center mb-2">
//                       <input
//                         type="checkbox"
//                         className="mr-2"
//                         style={{ width: "15px", height: "15px" }}
//                       />
//                       <span>Pending</span>
//                     </div>

//                     <div className="d-flex align-items-center mb-2">
//                       <input
//                         type="checkbox"
//                         className="mr-2"
//                         style={{ width: "15px", height: "15px" }}
//                       />
//                       <span>Not Recommended</span>
//                     </div>

//                     <div className="d-flex align-items-center mb-2">
//                       <input
//                         type="checkbox"
//                         className="mr-2"
//                         style={{ width: "15px", height: "15px" }}
//                       />
//                       <span>HOD Recommended</span>
//                     </div>
//                   </div>

//                   {/* Officer Details */}
//                   <div className="mt-4">
//                     <div className="d-flex mb-2">
//                       <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                         <p className="mb-0">Name of Screening Officer:</p>
//                       </div>
//                       <div>
//                         <p className="mb-0">................................</p>
//                       </div>
//                     </div>

//                     <div className="d-flex mb-2">
//                       <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                         <p className="mb-0">Signature & Date:</p>
//                       </div>
//                       <div>
//                         <p className="mb-0">................................</p>
//                       </div>
//                     </div>

//                     <div className="d-flex mb-2">
//                       <div style={{ minWidth: "200px", fontWeight: "bold" }}>
//                         <p className="mb-0">Remarks:</p>
//                       </div>
//                       <div style={{ flexGrow: 1 }}>
//                         <p className="mb-0">
//                           ....................................................................
//                           <br />
//                           ....................................................................
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Paper>
//       </>
//     );
//   }
// }

// const mapStateToProps = ({ settings, auth }) => {
//   const authUser = auth.applicantUser;
//   const { userMode } = auth;
//   return { authUser, userMode };
// };

// export default connect(mapStateToProps, { applicant })(ApplicantForm);
